module.exports = __webpack_public_path__ + "img/arrow-left-edge.2db40032.svg";